import { render, staticRenderFns } from "./ObjectAssignees.vue?vue&type=template&id=6cad3fd2&scoped=true"
import script from "./ObjectAssignees.vue?vue&type=script&lang=js"
export * from "./ObjectAssignees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad3fd2",
  null
  
)

export default component.exports